import { render, staticRenderFns } from "./manualBillGenerationList.vue?vue&type=template&id=f4771088"
import script from "./manualBillGenerationList.vue?vue&type=script&lang=js"
export * from "./manualBillGenerationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports